// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tCB_","delete":"styles_delete__1aP3U","update":"styles_update__3qiTb","add":"styles_add__2JqDv"};